<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'BackButton',
});
</script>
<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

;

const props = withDefaults(
  defineProps<{
    /** 按钮文字，默认为"返回" */
    label?: string;
    /** 自定义容器类名 */
    containerClass?: string;
  }>(),
  {
    label: '',
    containerClass: '',
  },
);

const emit = defineEmits<{
  /** 点击返回按钮前触发，可用于自定义返回逻辑 */
  back: [];
}>();

const { t } = useI18n();
const router = useRouter();

/** 处理返回操作 */
const handleBack = () => {
  emit('back');
  router.back();
};
</script>

<template>
  <div :class="['btns', containerClass]">
    <el-button class="btn" @click="handleBack">
      {{ label || t('返回') }}
    </el-button>
  </div>
</template>

<style lang="scss" scoped>
.btns {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}
</style>
